import React from "react";
import PropTypes from "prop-types";
import EmailField from "../../Register/EmailField/EmailField";
import Translate from "../../../hoc/Locale/Translate";
import { translateAsLiteral } from "../../../helpers/utility";
import { Form, Button, Alert } from "reactstrap";

const SendConfirmEmailLinkForm = (props) => {
  const {
    success,
    error,
    isOpen,
    toggle,
    appLanguage,
    handleValidSubmit,
    values,
    onChange,
    doMinimaliseText,
    validate,
    onUpdateValidate,
  } = props;

  let colour = "warning";
  let successMessage, errorMessage;

  if (success) {
    colour = "success";
    successMessage = (
      <p>
        <Translate id="SendConfirmEmail.Success" />
      </p>
    );
  } else if (error) {
    colour = "danger";
    errorMessage = (
      <p>
        <Translate id="SendConfirmEmail.Error" />
      </p>
    );
  }

  const headerText = doMinimaliseText ? (
    <h5 style={{ textTransform: "none" }}>
      <Translate id="SendConfirmEmail.Header.MinimaliseText" />
    </h5>
  ) : (
    <h4 className="alert-heading">
      <Translate id="SendConfirmEmail.Header" />
    </h4>
  );

  return (
    <Alert className="mx-auto w-50" color={colour} isOpen={isOpen} toggle={toggle}>
      {headerText}
      {successMessage}
      {errorMessage}

      <Form onSubmit={handleValidSubmit}>
        <EmailField
          label={translateAsLiteral(appLanguage, "ForgotPassword.YourEmail")}
          appLanguage={appLanguage}
          validate={validate}
          onUpdateValidate={onUpdateValidate}
          onChange={onChange}
          value={values?.email || ""} // Safe fallback
        />

        {!doMinimaliseText && (
          <div>
            <Translate id="SendConfirmEmail.Hint" />
            <br />
          </div>
        )}

        <Button className="my-2" color="primary">
          <Translate id="SendConfirmEmail.Button" />
        </Button>
      </Form>
    </Alert>
  );
};

// PropTypes
SendConfirmEmailLinkForm.propTypes = {
  appLanguage: PropTypes.string.isRequired,
  success: PropTypes.bool,
  error: PropTypes.bool,
  isOpen: PropTypes.bool,
  doMinimaliseText: PropTypes.bool,
  toggle: PropTypes.func,
  handleValidSubmit: PropTypes.func,
  values: PropTypes.shape({
    email: PropTypes.string,
  }),
  onChange: PropTypes.func,
  validate: PropTypes.func,
  onUpdateValidate: PropTypes.func,
};

// Default props
SendConfirmEmailLinkForm.defaultProps = {
  success: false,
  error: false,
  isOpen: true,
  doMinimaliseText: false,
  toggle: () => {},
  handleValidSubmit: () => {},
  values: { email: "" },
  onChange: () => {},
  validate: () => {},
  onUpdateValidate: () => {},
};

export default SendConfirmEmailLinkForm;
